import gql from "graphql-tag";

export const createOdeReport = gql`
  mutation CreateOdeReport($data: ReportCreateInput!) {
    createReport(data: $data){
      id
    }
  }
`;